// Fetch single piece details
export const fetchPieceDetails = async (sdk, pieceId) => {
  try {
    const response = await sdk.newSdk.pieces.show({ id: pieceId, include: ['listing', 'listing.provider'] });
    return response.data;
  } catch (error) {
    console.error(`Error fetching piece with ID ${pieceId}:`, error);
    throw error;
  }
};

// Fetch piece events with included relationships
export const fetchPieceEvents = async (sdk, pieceId) => {
  try {
    const response = await sdk.newSdk.pieceEvents.query({
      pieceId,
      include: ['employee', 'transaction', 'transferFromListing', 'transferToListing', 'transferFromListing.provider', 'transferToListing.provider']
    });
    // Return full response to retain access to the 'included' array for relationships
    return response;
  } catch (error) {
    console.error(`Error fetching events for piece ${pieceId}:`, error);
    throw error;
  }
};